<div style="margin-left: 5%; margin-right: 5%; padding-left: 20px;
padding-right: 20px; background-color: #ffffff">
    <div fxLayout="row wrap" fxLayoutAlign="start center">
        <table style="width: 100%;">
            <tr>
                <td style="width: 80%;">
                    <div style="margin-top: 0px; margin-bottom: -10px; width: 95%;">
                        {{lblTitRegEmisor}}
                    </div>
                </td>
                <td style="width: 20%;">
                    <i class="fas fa-qrcode" style="width: 10px; margin-right: 20px;
                  font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                  margin-top: 0px; margin-right: 20px;" (click)="solicitaqr()">
                    </i>
                </td>
            </tr>
        </table>
    </div>
    <div style="text-align: center; margin-top: 20px;">
        <table style="width: 100%;">
            <tr>
                <td style="width: 30%;"></td>
                <td style="width: 30%;">
                    <button mat-raised-button mat-dialog-close class="btn-agregar">
                        <i class="fas fa-window-close fa-1x" style="width: 20px; margin-right:10px;
                        font-size: 1.5em; cursor: pointer;"></i>
                        Cerrar
                    </button>
                </td>
                <td style="width: 30%;"></td>
            </tr>
        </table>
    </div>
</div>